module.exports = __webpack_public_path__ + "static/img/tarjetas_prepago_category.a56cd0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/old/tarjetas_prepago_category.jpg
// module id = +SqR
// module chunks = 1